
import axios, { AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import WsdlService from "@/services/WsdlService";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import UmbracoApiService from "@/services/UmbracoApiService";
import MiInversionModel from "@/models/MiInversion/MiInversionModel";
import MiInversionForm from "@/components/Mi_Inversion/MiInversionForm.vue";
import MiInversionResult from "@/components/Mi_Inversion/MiInversionResult.vue";
import Swal from "sweetalert2";
import FundType from "@/models/WsdlResponses/FundType";

@Component({
  components: {
    MiInversionForm,
    MiInversionResult,
  },
})
export default class MiInversion extends Vue {
  public tipoFondo: Array<FundTypeObj> = [];
  public wsdlService: WsdlService = new WsdlService();
  public userId: string = this.$store.state.user.cedula;
  public showResult: boolean = false;
  public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;
  public umbracoService = new UmbracoApiService();
  public isLoading: boolean = false;
  public miInversion = new MiInversionModel();
  public image: string = "";
  public FinalDate: string = "";
  public rentAcumulated: any = {};
  public rent: any = {};

  constructor() {
    super();
  }
  async mounted() {
    await this.getData();
    await this.getDropdownData();
    await this.getMinMaxDate();
  }

  public process(tipoFondo: FundType, toDate: string) {
    if (toDate) {
      this.isLoading = true;
      this.getRentData(tipoFondo, toDate)
        .then((response) => {
          this.showResult = true;
        })
        .catch((ex) => {
          Swal.fire({
            text: "¡Lo sentimos! Ha ocurrido un error en la consulta",
            icon: "error",
            showConfirmButton: true,
            confirmButtonText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      Swal.fire({
        text: "Debe seleccionar una fecha final para consultar su inversión",
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: "Ok",
      });
    }
  }
  public async getRentData(tipoFondo: FundType, toDate: string) {
    // await this.getDatesVigencia(tipoFondo);
    await this.getRentabilidadAcumulada(tipoFondo, toDate);
    await this.getRentabilidad(tipoFondo, toDate);
  }
  public async getDatesVigencia(tipoFondo: FundType) {
    await this.wsdlService
      .GetFechaVigencia(tipoFondo.tipofondo, this.FinalDate)
      .then((response) => {
        if (!response.data[0].fecvigencia) return;
        let iDate = new Date(response.data[0].fecvigencia);
        this.FinalDate = this.getFormattedDate(iDate);
      });
  }
  public async getRentabilidadAcumulada(tipoFondo: FundType, toDate: string) {
    await this.wsdlService
      .GetRentabilidadAcumulada(
        this.userId,
        tipoFondo.codcuenta,
        this.FinalDate
      )
      .then((response: AxiosResponse<any>) => {
        this.rentAcumulated = response.data;
      });
  }
  public async getRentabilidad(tipoFondo: FundType, toDate: string) {
    await this.wsdlService
      .GetRentabilidad(
        this.userId,
        tipoFondo.codcuenta,
        "07/07/2003",
        this.FinalDate
      )
      .then((response: AxiosResponse<any>) => {
        this.rent = this.rent = response.data;
      });
  }
  public getMinMaxDate() {
    this.wsdlService.GetMinMaxValues("2").then((resp) => {
      let iDate = new Date(resp.data[0].maxfecha);
      this.FinalDate = this.getFormattedDate(iDate);
    });
  }
  public returnForm() {
    this.showResult = false;
  }
  public async getDropdownData() {
    this.wsdlService
      .getTipoDeFondos(this.userId, "")
      .then((response: AxiosResponse<FundTypeObj>) => {
        this.tipoFondo.push(response.data);
      });
  }
  public getFormattedDate(date: Date): string {
    let year = date.getFullYear();

    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : "0" + month;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : "0" + day;

    return day + "/" + month + "/" + year;
  }

  async getData() {
    await this.umbracoService.getMiInversion().then((resp) => {
      this.miInversion = resp;
      this.image = `${this.umbracoBaseUrl}${resp.image}`;
    });
  }
}
